// extracted by mini-css-extract-plugin
export default {"page-foot":"styles-module_page-foot__ELephC","align-right":"styles-module_align-right__txzus_","align-between":"styles-module_align-between__h9MWyS"};